/**
 * Scan sequence constants.
 *
 * Kept in their own module — free of any browser dependency — so unit tests can
 * import them without pulling in the hook, which reaches for `window` through
 * Wasp's api client.
 */

export type ScanStepId = "reading" | "sessions" | "playbook" | "leaks" | "writing";

export const SCAN_STEPS: ScanStepId[] = ["reading", "sessions", "playbook", "leaks", "writing"];

/**
 * Minimum time the scan sequence stays on screen, even when the API answers sooner.
 * A deliberate product trade-off: the reveal is the showcase moment. With haiku the
 * model often replies in 3-5s, so this does add real waiting — tune here, not inline.
 */
export const MIN_SCAN_MS = 8000;
